export const SET_SHARE_MODAL_DATA = 'SET_SHARE_MODAL_DATA';
export const CLOSE_SHARE_MODAL = 'CLOSE_SHARE_MODAL';
